import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipAltComponent } from './tooltip-alt.component';
import { WmTransitionModule } from '../transition/index';
import { WmIconModule } from '../icon/index';

@NgModule({
	declarations: [TooltipAltComponent],
	imports: [CommonModule, WmTransitionModule, WmIconModule],
	exports: [TooltipAltComponent]
})
export class WmTooltipAltModule {}
